import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class SupplierRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/suppliers');
    }

    async getAll() {
        if (Cache.get('suppliers')) {
            return Cache.get('suppliers');
        }

        return this.where('per_page', 1000).run().then((res) => {
            Cache.set('suppliers', res.data);
            return Cache.get('suppliers');
        });
    }
}
